import React, { useContext, useEffect } from "react";
import { useFetchAuth } from "api";
import { ContextStore } from "Reducer/index";
import { useHistory, useLocation } from "react-router-dom";

export default () => {
  const {
    state: { stateReducer },
  } = useContext(ContextStore);
  const history = useHistory();
  const query = useLocation().search;
  const getAuth = stateReducer.get("getAuth");
  const pathname = useLocation().pathname;
  const isAuth = stateReducer.get("isAuth");
  const isMaintain = stateReducer.get("isMaintain");

  useEffect(() => {
    if (window.location.hash.match(/Home/) && getAuth && getAuth) return;
    if (!isAuth && pathname) history.push(`/authFail${query}`);
    if (isMaintain) history.push(`/Maintain${query}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, isAuth, isMaintain, pathname, getAuth]);

  useEffect(() => {
    if (window.location.hash.match(/authFail/) && getAuth) {
      window.location.href = `/#/Home${query}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAuth, isAuth]);

  useFetchAuth();

  return <></>;
};
